import { GoogleButton } from "./GoogleButton";
import { MicrosoftButton } from "./MicrosoftButton";
import { AppleButton } from "./AppleButton";
import { useAuth } from "@/hooks/useAuth";

interface SocialLoginButtonsProps {
  mode: "login" | "register";
}

export function SocialLoginButtons({ mode }: SocialLoginButtonsProps) {
  const { signInWithMicrosoft, signInWithApple } = useAuth();

  return (
    <div className="space-y-3">
      <GoogleButton mode={mode} />
      <MicrosoftButton mode={mode} onClick={signInWithMicrosoft} />
      <AppleButton mode={mode} onClick={signInWithApple} />
    </div>
  );
}